import io from 'socket.io-client';
import {constant} from '../../common/constant';
import {Encryption, Decryption} from '../../common/functions'
import {eraseCookie, getCookie} from 'ubs-framework/v2/common/cookie';

let socket;
export {socket}
export const socketConnect = (dispatch, next) => {
    socket = io.connect(`${process.env.REACT_APP_ACCOUNT_SOCKET_URL}?token=${getCookie('ubs_token')}&flag=Account`, {
        "transports": ['websocket']
    })
    socket.on('connect', () => {
        dispatch({type: 'SOCKET_CONNECTION', payload: socket.connected})
        next(socket.connected)
    })
    socket.on('response', response => {
            let res;
            if (typeof response === 'string') res = Decryption(response)
            else res = response
            console.log('response ===>', res);
            if (!res.error) {
                if (res.data.error) {
                    alert(res.data.error);
                } else {
                    switch (res.event) {
                        case 'login':
                            if (!res.data.activateAccount) {
                                dispatch({type: 'LOGIN', payload: res.data});
                                dispatch({type: 'AUTHENTICATE', payload: res?.data})
                            }
                            break;
                        case 'authenticate':
                            dispatch({type: 'LOGIN', payload: res.data});
                            dispatch({type: 'AUTHENTICATE', payload: res?.data, isAdmin: res?.data?.isAdmin})
                            dispatch({type: 'SET_IS_ADMIN', payload: res?.data?.isAdmin})
                            break;
                        default:
                            break;
                    }
                }
            } else {
                if (res.code === 401 || (res.event === 'authenticate' && !res.data?.isUserMFASetup)) {
                    dispatch({type: 'LOGOUT'}); if (localStorage.getItem('notification_token')) sendData('logout', {device_token: localStorage.getItem('notification_token')})
                    dispatch({type: 'LOGOUT'});
                    localStorage.clear()
                    eraseCookie('ubs_token')
                    eraseCookie('ubsTabId')
                    window.location.reload(true)
                }
            }
        }
    );
};

const prepareData = (event, data) => {
    console.log(`(((${event})))`, data);
    return Encryption({event, data})
};

export const sendData = (dispatch, en, data) => {
    if (socket.connected) socket.emit('request', prepareData(en, data));
}
export const responseHandler = (response) => {
    let res;
    if (typeof response === 'string') res = Decryption(response)
    else res = response
    return res;
}
